import React from 'react';

const SvgRewards = props => (
  <svg width="1em" height="1em" viewBox="0 0 18 17" {...props}>
    <path d="M8.944.003a.718.718 0 0 0-.563.345L5.658 4.871.572 5.906a.727.727 0 0 0-.542.512.748.748 0 0 0 .182.731l3.713 3.798-.675 5.167a.744.744 0 0 0 .279.677.707.707 0 0 0 .711.094L9 14.802l4.76 2.083c.236.1.507.064.711-.094a.744.744 0 0 0 .279-.677l-.338-2.612a.724.724 0 0 0-.81-.633.734.734 0 0 0-.619.828l.18 1.324-3.882-1.703a.705.705 0 0 0-.562 0L4.837 15.02l.551-4.247a.747.747 0 0 0-.202-.61L2.18 7.092l4.085-.84a.72.72 0 0 0 .472-.334L9 2.155l2.262 3.763a.72.72 0 0 0 .472.334l4.085.84-3.005 3.072a.746.746 0 0 0-.25.74.73.73 0 0 0 .54.552.711.711 0 0 0 .723-.256l3.96-4.05a.748.748 0 0 0 .183-.732.727.727 0 0 0-.542-.512l-5.086-1.035L9.619.348a.715.715 0 0 0-.675-.345z" />
  </svg>
);

export default SvgRewards;
